import styled from 'styled-components';
import { colors, sizes, fontSizes, radiuses, shadows, sizesRaw } from '../ui';

export const Wrapper = styled.div`
  .spinner {
    color: ${colors.neutral700};
    font-size: ${fontSizes.s3};
  }

  .status-block {
    margin: ${sizes.s4} 0;
    padding: ${sizes.s3} ${sizes.s4};
    border-radius: ${radiuses.r3};
    background-color: #fff;
    box-shadow: ${shadows.s1};
    text-align: center;
    font-size: ${fontSizes.s3};
    color: ${colors.neutral700};

    &.status-empty {
      border: 1px dashed ${colors.neutral300};
      background-color: ${colors.neutral100};
    }

    &.status-error {
      border: 1px solid ${colors.danger200};
      background-color: ${colors.danger100};
      color: ${colors.danger700};
    }

    .details {
      display: block;
      margin-top: ${sizes.s1};
      font-size: ${fontSizes.s2};
    }

    .retry-button {
      margin-top: ${sizes.s3};
      padding: ${sizes.s1} ${sizes.s3};
      border-radius: ${radiuses.r2};
      border: none;
      background-color: ${colors.primary500};
      color: #fff;
      font-size: ${fontSizes.s3};
      cursor: pointer;
      transition: opacity 150ms ease, transform 150ms ease;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:active:not(:disabled) {
        transform: translateY(1px);
      }

      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }
  }

  .packages {
    font-size: ${fontSizes.s3};

    table.packages {
      margin: ${sizes.s5} 0px 0px;

      td {
        padding: 2px ${sizes.s2};

        &:first-child {
          padding-left: 0px;
        }

        font-size: ${fontSizes.s3};

        &.caption {
          max-width: ${sizes.s11};
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &.right {
          text-align: right;
        }

        &.center {
          text-align: center;
        }
      }

      .img-container {
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }

        transition: opacity 300ms ease;
      }
    }

    main {
      overflow-x: scroll;
    }

    footer {
      margin-top: ${sizes.s4};
      display: flex;
      justify-content: flex-end;

      button {
        background: none;
        border: none;
        padding: 0;
        font-size: inherit;
        font-family: inherit;
        color: ${colors.neutral700};
        text-decoration: underline;
        cursor: pointer;

        &:hover {
          color: ${colors.neutral900};
        }

        transition: color 150ms ease;
      }
    }
  }

  .photos-container {
    display: flex;
    column-gap: ${sizes.s2};
  }

  ul.orders {
    margin: 0px;
    padding: 0px;
    list-style-type: none;

    & > li {
      padding: ${sizes.s3} ${sizes.s4};
      box-shadow: ${shadows.s2};
      border-radius: ${radiuses.r3};
      background-color: #fff;

      &:not(.expanded) {
        &:hover,
        &:active {
          opacity: 0.7;
          cursor: pointer;
        }

        transition: opacity 300ms ease;
      }

      header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left-side {
          h3 {
            font-size: ${fontSizes.s4};
            margin: 0px;
          }

          .timestamp {
            color: ${colors.neutral600};
            font-size: ${fontSizes.s2};
          }
        }

        .right-side {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          row-gap: ${sizes.s2};

          .labels {
            display: flex;

            .label {
              &:not(:first-child) {
                margin-left: ${sizes.s1};
              }
            }
          }

          .circles {
            display: flex;

            .circle {
              height: ${sizes.s4};
              width: ${sizes.s4};
              border-radius: ${sizesRaw.s4 / 2}px;

              &:not(:first-child) {
                margin-left: ${sizes.s1};
              }

              &.circle-gray {
                background-color: ${colors.neutral300};
              }

              &.circle-green {
                background-color: ${colors.success600};
              }
            }
          }
        }
      }

      margin-bottom: ${sizes.s4};
    }
  }

  ul.packages {
    margin: ${sizes.s4} 0px 0px;
    padding: 0px;
    list-style-type: none;

    & > li {
      margin-bottom: 8px;
      font-size: ${fontSizes.s3};
    }
  }

  /* Pagination block */
  .pagination {
    margin-top: ${sizes.s5};
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: ${sizes.s3};
    color: ${colors.neutral800};

    .page-info {
      font-size: ${fontSizes.s3};
      color: ${colors.neutral700};
      display: inline-flex;
      align-items: center;
      column-gap: ${sizes.s2};
    }

    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: ${sizes.s1} ${sizes.s3};
      background-color: #fff;
      border: 1px solid ${colors.neutral300};
      border-radius: ${radiuses.r2};
      color: ${colors.neutral900};
      font-size: ${fontSizes.s3};
      box-shadow: ${shadows.s1};
      cursor: pointer;
      transition: background-color 150ms ease, color 150ms ease, opacity 150ms ease;

      &:hover:not(:disabled) {
        background-color: ${colors.neutral100};
      }

      &:active:not(:disabled) {
        background-color: ${colors.neutral200};
      }

      &:disabled {
        cursor: default;
        opacity: 0.5;
      }
    }

    .limit-control {
      display: inline-flex;
      align-items: center;
      column-gap: ${sizes.s2};

      label {
        color: ${colors.neutral700};
        font-size: ${fontSizes.s3};
      }

      select {
        height: ${sizes.controlHeightSmall};
        padding: 0 ${sizes.s2};
        border: 1px solid ${colors.neutral300};
        border-radius: ${radiuses.r2};
        background-color: #fff;
        color: ${colors.neutral900};
        box-shadow: ${shadows.s1};
      }
    }

    /* Tiny inline spinner to indicate background page loading */
    .small-spinner {
      width: 12px;
      height: 12px;
      border: 2px solid ${colors.neutral300};
      border-top-color: ${colors.neutral700};
      border-radius: 50%;
      display: inline-block;
      animation: spin 600ms linear infinite;
    }
  }

  /* Responsive tweaks for mobile */
  @media (max-width: 600px) {
    .pagination {
      flex-wrap: wrap;
      row-gap: ${sizes.s2};
      column-gap: ${sizes.s2};

      .btn {
        padding: ${sizes.s1} ${sizes.s2};
        font-size: ${fontSizes.s2};
      }

      .page-info {
        font-size: ${fontSizes.s2};
      }

      .limit-control {
        width: 100%;
        justify-content: center;

        label { margin-right: ${sizes.s1}; }
        select {
          height: ${sizes.controlHeightTiny};
          font-size: ${fontSizes.s2};
        }
      }
    }
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
